import { SubjectDto, SubjectRestControllerService } from 'generated';
import { useCallback, useEffect, useState } from 'react';
import { apiWrapper } from 'utils/http-client';
import { handleError } from 'utils/utils';

interface IProps {
  classLevelId: string;
}

const useSubjectsByClassLevelsFetch = ({ classLevelId }: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [subjects, setSubjects] = useState<SubjectDto[]>([]);

  const fetchSubjects = useCallback(async () => {
    setLoading(true);
    try {
      const data = await apiWrapper(() =>
        SubjectRestControllerService.getClassSubjectsUsingGet({
          classLevelId,
        }),
      );
      setSubjects(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  }, [classLevelId]);

  useEffect(() => {
    if (classLevelId) {
      fetchSubjects();
    }
  }, [fetchSubjects, classLevelId]);

  return {
    loadingSubjects: loading,
    fetchSubjects,
    subjects,
  };
};

export default useSubjectsByClassLevelsFetch;
